var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("Header", _vm._b({}, "Header", _vm.$route.meta, false)),
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column is-3 has-text-centered" },
              [
                _c(
                  "b-field",
                  [
                    _c("b-input", {
                      attrs: {
                        placeholder: "Search...",
                        type: "search",
                        icon: "search",
                      },
                      model: {
                        value: _vm.search,
                        callback: function ($$v) {
                          _vm.search = $$v
                        },
                        expression: "search",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column" },
              [
                _c(
                  "b-table",
                  {
                    attrs: {
                      "per-page": 15,
                      data: _vm.fileteredEndusers,
                      selected: _vm.selectedEnduser,
                      loading: _vm.isLoading,
                      narrowed: "",
                      striped: "",
                      paginated: "",
                    },
                    on: {
                      "update:selected": function ($event) {
                        _vm.selectedEnduser = $event
                      },
                      contextmenu: _vm.showMenu,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function (props) {
                          return [
                            _c("span", [_vm._v(_vm._s(props.column.label))]),
                          ]
                        },
                      },
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _c(
                              "b-table-column",
                              {
                                attrs: {
                                  field: "name",
                                  label: "Customer name",
                                  width: "100px",
                                  sortable: "",
                                },
                              },
                              [_vm._v(" " + _vm._s(props.row.name) + " ")]
                            ),
                            _c(
                              "b-table-column",
                              {
                                attrs: {
                                  field: "country",
                                  label: "Country",
                                  sortable: "",
                                },
                              },
                              [_vm._v(" " + _vm._s(props.row.country) + " ")]
                            ),
                            _c(
                              "b-table-column",
                              {
                                attrs: {
                                  field: "city",
                                  label: "City",
                                  sortable: "",
                                },
                              },
                              [_vm._v(" " + _vm._s(props.row.city) + " ")]
                            ),
                            _c(
                              "b-table-column",
                              {
                                attrs: {
                                  field: "stock",
                                  label: "Stock",
                                  sortable: "",
                                  numeric: "",
                                },
                              },
                              [_vm._v(" " + _vm._s(props.row.stock) + " ")]
                            ),
                            _c(
                              "b-table-column",
                              {
                                attrs: {
                                  field: "deemedLost",
                                  label: "Lost",
                                  meta: "Deemed as lost",
                                  sortable: "",
                                  numeric: "",
                                },
                              },
                              [
                                _c("span", { staticClass: "has-text-danger" }, [
                                  _vm._v(
                                    " " + _vm._s(props.row.deemedLost) + " "
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "b-table-column",
                              {
                                attrs: {
                                  field: "averageRentalDays",
                                  label: "Average rental days",
                                  sortable: "",
                                  numeric: "",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(props.row.averageRentalDays) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [_c("template", { slot: "empty" }, [_c("nothing-here")], 1)],
                  2
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("context-menu", { ref: "loadContextMenu" }, [
        _c("div", { staticClass: "dropdown-menu" }, [
          _c("div", { staticClass: "dropdown-content" }, [
            _c(
              "a",
              { staticClass: "dropdown-item" },
              [
                _c("b-icon", {
                  attrs: { icon: "box", type: "is-warning", size: "is-small" },
                }),
                _c("span", [_vm._v("Stock")]),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }